import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MyCoursesFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.733 6.14.88 15.588l20.853 10.498L43.12 15.588 21.733 6.14Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.907 21a.88.88 0 0 1-.394 1.18l-21.11 10.555a.883.883 0 0 1-.806 0L.487 22.18a.88.88 0 1 1 .787-1.574L22 30.969l20.726-10.363a.88.88 0 0 1 1.18.393Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.907 26.866a.88.88 0 0 1-.394 1.18l-21.11 10.556a.877.877 0 0 1-.806 0L.487 28.047a.88.88 0 0 1 .787-1.575L22 36.836l20.726-10.364a.88.88 0 0 1 1.18.394Z"
  }));
});
MyCoursesFill.displayName = 'MyCoursesFill';
MyCoursesFill.defaultProps = {
  'aria-label': 'MyCoursesFill'
};
export default MyCoursesFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MyCoursesFill.js
// module id = 3224
// module chunks = 11